import DealershipMiddleContent from './DealershipMiddleContent';

export default DealershipMiddleContent;
